import styled from "styled-components";
import {GAMING_HISTORY_PAGE, LOBBY_PAGE, SESSION_HISTORY_PAGE, STICKY, GAMES_OPEN_SESSIONS_PAGE} from "../../../../themes/css-global-classes";

export const LobbyHeaderLineDefaultBox = styled.div`
    .${LOBBY_PAGE} &{
        display:none;
    }
    .${GAMING_HISTORY_PAGE} &, .${SESSION_HISTORY_PAGE} &, .${GAMES_OPEN_SESSIONS_PAGE} &{
        width: 100%;
        height: 2px;
        background: linear-gradient(to right, ${props => props.theme.colors.brandPrimary}, ${props => props.theme.colors.brandSecondary});
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 97%;
        border-top: 1px solid ${props => props.theme.colors.boxBorderDark};
        border-bottom: 1px solid ${props => props.theme.colors.boxBorderLighter};

        .${STICKY} &{
            width: 100%;
            border-top: none;
            border-bottom: 1px solid ${props => props.theme.colors.brandPrimary};
        }
    }
`;
